/**
https://github.com/MeCKodo/vue-tap
使用方法
```
import vTap from 'v-tap'
Vue.use(vTap);

<a v-tap.prevent @tap="call"/>
<a v-tap.stop @tap="call"/>

methods:{
  call(event,tapObj){

  }
}

>
```
 * */

/**                               公用方法开始                 **/
function isPc() {
  const uaInfo = navigator.userAgent;
  const agents = ['Android', 'iPhone', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  for (const item of agents) {
    if (uaInfo.indexOf(item) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

function emit(vnode, name, ...data) {
  const handlers = (vnode.data && vnode.data.on) ||
    (vnode.componentOptions && vnode.componentOptions.listeners);

  if (handlers && handlers[name]) {
    handlers[name].fns(...data);
  }
}

class Helper {
  public click;
  public touchstart;
  public touchend;
  public handler;
  public time;
  public tapObj = {
    pageX: 0,
    pageY: 0,
    clientX: 0,
    clientY: 0,
    distanceX: 0,
    distanceY: 0,
  };

  public isTap(self) {
    if (self.disabled) {
      return false;
    }
    const tapObj = this.tapObj;
    return this.time < 300 &&
      Math.abs(tapObj.distanceX) < 10 &&
      Math.abs(tapObj.distanceY) < 10;
  }
  public setMethod(el, binding, vnode) {
    const me = this;
    this.handler = function (e, isPcFlag) {
      if (el.href && !binding.modifiers.prevent) {
        return window.location = el.href;
      }

      const tagName = e.target.tagName.toLocaleLowerCase();

      if (tagName === 'input' || tagName === 'textarea') {
        return e.target.focus();
      }
      emit(vnode, 'tap', e, me.tapObj);
    };
    if (isPc()) {
      this.click = function (e) {
        if (binding.modifiers.stop) {
          e.stopPropagation();
        }
        if (binding.modifiers.prevent) {
          e.preventDefault();
        }
        me.handler(e, true);
      };
    } else {
      this.touchstart = function (e) {

        if (binding.modifiers.stop) {
          e.stopPropagation();
        }
        if (binding.modifiers.prevent) {
          e.preventDefault();
        }

        const touches = e.touches[0];
        const tapObj = me.tapObj;
        tapObj.pageX = touches.pageX;
        tapObj.pageY = touches.pageY;
        tapObj.clientX = touches.clientX;
        tapObj.clientY = touches.clientY;
        me.time = +new Date();
      };
      this.touchend = function (e) {
        const touches = e.changedTouches[0];
        const tapObj = me.tapObj;
        me.time = +new Date() - me.time;
        tapObj.distanceX = tapObj.pageX - touches.pageX;
        tapObj.distanceY = tapObj.pageY - touches.pageY;

        if (e.cancelable !== false) {
          e.preventDefault();
        }

        if (!me.isTap(self)) {
          return;
        }
        me.handler(e);
      };
    }
  }
  public addListener(el) {
    if (isPc()) {
      el.addEventListener('click', this.click, false);
    } else {
      el.addEventListener('touchstart', this.touchstart, false);
      el.addEventListener('touchend', this.touchend, false);
    }
  }
  public removeListener(el) {
    if (isPc()) {
      if (this.click) {
        el.removeEventListener('click', this.click, false);
      }
    } else {
      if (this.touchstart) {
        el.removeEventListener('touchstart', this.touchstart, false);
      }
      if (this.touchend) {
        el.removeEventListener('touchend', this.touchend, false);
      }
    }
  }
}

const tap = {
  bind(el, binding, vnode) {
    const helper = new Helper();
    helper.setMethod(el, binding, vnode);
    helper.addListener(el);
    el.vTapHelper = helper;
  },
  componentUpdated(el, binding, vnode) {

    const helper = el.vTapHelper as Helper;
    helper.tapObj = {} as any;
    helper.handler = function (e) {
      if (el.href && !binding.modifiers.prevent) {
        return window.location = el.href;
      }
      emit(vnode, 'tap', e, el.tapObj);
    };
  },
  unbind(el) {
    const helper = el.vTapHelper as Helper;
    helper.removeListener(el);
    helper.handler = () => {
      //
    };
  },
};

const vueTap = {
  install(Vue) {
    Vue.directive('tap', tap);
  },
};
export default vueTap;



// WEBPACK FOOTER //
// ./src/assets/js/v-tap.ts